export default "__VITE_ASSET__28f8ca9c__"